// The .page layout: the fixed sidebar (--sidebar-w) and the main area beside it.
import { Outlet } from 'react-router';
import type { Api } from '../auth/api';
import { useMe } from '../auth/user';
import type { NavCounts } from './nav-counts';
import { Sidebar } from './Sidebar';
import { OfflineBar } from './SystemStates';

type AppShellProps = {
  counts: NavCounts;
  api: Api;
};

export function AppShell({ counts, api }: AppShellProps) {
  const me = useMe();
  return (
    <div className="page">
      <Sidebar me={me} counts={counts} api={api} />
      <main className="main">
        <OfflineBar />
        <Outlet />
      </main>
    </div>
  );
}
